import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Catalog from "@/components/Catalog";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Footer from "@/components/Footer";
import GamePage from "@/pages/GamePage";
import { useSeo } from "@/hooks/useSeo";
import { translations } from "@/i18n";

const Home = ({ t, lang }) => {
  const { hash } = useLocation();

  useSeo({ title: t.meta.title, description: t.meta.description, path: "/" });

  useEffect(() => {
    if (hash) {
      document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  return (
    <main id="main-content">
      <Hero t={t} />
      <Catalog t={t} lang={lang} />
      <Marquee t={t} />
      <Manifesto t={t} />
    </main>
  );
};

function App() {
  const [lang, setLang] = useState("it");
  const t = translations[lang];

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <BrowserRouter>
      <div className="min-h-screen bg-[#05050A] text-white font-body overflow-x-hidden">
        <a href="#main-content" data-testid="skip-link" className="skip-link">
          {t.a11y.skip}
        </a>
        <div className="noise-overlay" aria-hidden="true" />
        <Header t={t} lang={lang} setLang={setLang} />
        <Routes>
          <Route path="/" element={<Home t={t} lang={lang} />} />
          <Route path="/giochi/:slug" element={<GamePage t={t} lang={lang} />} />
          <Route path="*" element={<GamePage t={t} lang={lang} />} />
        </Routes>
        <Footer t={t} />
      </div>
    </BrowserRouter>
  );
}

export default App;
